(function () {
  'use strict';

  function init() {
    var menuLinks = document.querySelectorAll('.menu-drawer a[href*="#"]');

    menuLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        var drawerEl = document.querySelector('header-drawer');
        if (drawerEl && drawerEl.isOpen) {
          drawerEl.close();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
